import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, NavLink, Outlet, useNavigate } from 'react-router-dom';
import './CPDProLandingPage.css';
export default function CPDProLandingPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  
  return (
    <div className="cpd-landing-page">
      <header className="cpd-header">
        <div className="container">
          <div className="cpd-logo" onClick={() => navigate('/cpd-pro')} style={{ cursor: 'pointer' }}>
            <h3>{t('appTitle', 'CPD Pro')}</h3>
            <span>{t('byProtagon', 'by Protagon')}</span>
          </div>

          <nav className="cpd-nav" aria-label="CPD Pro navigation">
            <NavLink to="/cpd-pro/abonnementen" className={({ isActive }) => isActive ? 'active' : ''}>
              Abonnementen
            </NavLink>
            <NavLink to="/cpd-pro/waarom-cpd-pro" className={({ isActive }) => isActive ? 'active' : ''}>
              Waarom CPD Pro?
            </NavLink>
            <NavLink to="/cpd-pro/accreditatie" className={({ isActive }) => isActive ? 'active' : ''}>
              Accreditatie
            </NavLink>
            <NavLink to="/cpd-pro/faq" className={({ isActive }) => isActive ? 'active' : ''}>
              FAQ
            </NavLink>
          </nav>

          <div className="cpd-header-actions">
            <Link to="/cpd-pro" className="btn-ghost">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <path d="M3 9.5 12 3l9 6.5" />
                <path d="M5 9.5V21h14V9.5" />
                <path d="M9.5 21v-6h5v6" />
              </svg>
              <span>Home</span>
            </Link>
          </div>
        </div>
      </header>

      <Outlet />

      <footer className="cpd-footer">
        <div className="container">
          <p>&copy; {new Date().getFullYear()} CPD Pro by Protagon</p>
          <p className="cpd-footer-links">
            <a href="/privacy-policy.html" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
            <span className="cpd-footer-sep">•</span>
            <a href="/terms-of-service.html" target="_blank" rel="noopener noreferrer">Terms of Service</a>
          </p>
        </div>
      </footer>
    </div>
  );
}